<div [className]="'tile bg-'+tileColorName"
     data-qa="erzeugungsanlage"
     [routerLink]="routingService.erzeugungsanlagePath()"
     [queryParams]="{erzeugungsanlage: erzeugungsanlage.westnetzId}"
     queryParamsHandling="merge">
    <div class="tile-container">
        <div class="tile-icon">
            <img [src]="ASSET_URL + '/innogy-icons/Negative/'+tileIconName"/>
            <span data-qa="anlagentyp">{{erzeugungsanlage.anlagentyp.abkuerzung}}</span>
        </div>
        <div class="tile-text">
            <h2 data-qa="westnetzId">
                {{erzeugungsanlage.westnetzId}}
            </h2>
            <div style="margin-bottom:8px;">
                <span data-qa="installierteLeistung">
                {{erzeugungsanlage?.installierteLeistungKW}} kW
                </span>
                <span data-qa="summenerzeuger">(&#8721;)</span>
            </div>
            <span>
                <span data-qa="ortsname">{{erzeugungsanlage.netzzuordnung.ortsname}}</span>
                <br/>
                <span data-qa="stationsname">{{erzeugungsanlage.netzzuordnung.stationsname}}</span> /
                <span data-qa="trafoFeldName">{{erzeugungsanlage.netzzuordnung.trafoFeldName}}</span>
            </span>
        </div>
    </div>
</div>
